<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
      <div class='container-fluid'>
          <div class='col-lg-12' style='padding:0px'>
            <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
              <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
              تم حفظ السجل بنجاح
            </div>
                <div class='col-lg-3 col-sm-3' style='padding-top: 10px;'>
                    <tbDate  :mytitle='dateTitle' v-model= 'record.date' ></tbDate>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>الفنى:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.tec_id">
                      <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
                        {{ technical.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                  <label>المخزن:</label>
                  <select class="form-control" style="padding: 0px" v-model="record.store_id">
                    <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                      {{ store.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                  <label>الحالة:</label>
                  <select class="form-control" style="padding: 0px" v-model="record.status">
                    <option v-for="item in types" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>مسدد عند التعاقد:</label>
                    <input @keypress="isLocked($event)" :value='record.presenter' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>اقساط مسددة:</label>
                    <input @keypress="isLocked($event)" :value='record.installment_total_paid' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>صيانات مسددة:</label>
                    <input @keypress="isLocked($event)" :value='record.maintenance_payment' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>إجمالى المسدد:</label>
                    <input @keypress="isLocked($event)" :value='record.total_pay' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>ثمن الفلتر</label>
                    <input @keypress="isLocked($event)" :value='record.amount' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>مصاريف تركيب</label>
                    <input @keypress="isLocked($event)" :value='record.installation_fee' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>صيانة</label>
                    <input @keypress="isLocked($event)" :value='record.maintenance' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>إجمالى المطلوب</label>
                    <input @keypress="isLocked($event)" :value='record.total_req' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>الباقى</label>
                    <input @keypress="isLocked($event)" :value='record.rest' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>تلفيات</label>
                    <input @keypress="isNumber($event)" v-on:input="updateAdded()" v-model="record.added" class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                    <label>المبلغ المطلوب</label>
                    <input @keypress="isLocked($event)" v-model="record.req" class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-3' style='padding: 35px 0px 30px 10px;  text-align:center;'>
                  <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <button @click='saveData()'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
                </div>
              <!-- /.table-responsive -->
          <!-- /.col-lg-12 -->
          </div>
       </div>
    <!-- /.container-fluid -->
</div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'SalesReturn',
  data () {
    return {
      dateTitle: 'التاريخ',
      validationErrors: '',
      technicals: {},
      contract_id: '',
      record: {},
      stores: {},
      req: 0,
      types: [{id: 0, name: 'تحت الطلب'}, {id: 1, name: 'تم استلام الفنى'}, {id: 2, name: 'تم استلام المخزن'}, {id: 3, name: 'تم التفكيك'}],
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false
    }
  },
  methods: {
    tabSelected () {
      let branches = JSON.parse(localStorage.getItem('Branches'))
      this.branche = branches[0].id
      // -----------------------------------------------------
      let i = branches.findIndex(x => x.id === parseInt(this.$store.state.customerData.branche_id))
      if (i > -1) {
        this.technicals = branches[i].technicals
        this.stores = branches[i].stores
      }
      // -----------------------------------------------------
      this.contract_id = this.$store.state.customerData.contract_id
      this.GetData()
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    GetData () {
      this.successShow = false
      this.errorShow = false
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getContractReturnData', {
        token: localStorage.getItem('token'),
        contract_id: this.contract_id
      })
        .then(({ data }) => {
          this.record = data[0]
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.status === 404) {
          }
          this.isLoadingData = false
        })
    },
    updateAdded () {
      this.record.req = (parseInt(this.record.maintenance || 0) + (parseInt(this.record.added || 0))) - (parseInt(this.record.maintenance_payment || 0) + (parseInt(this.record.installment_total_paid || 0)))
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveSalesReturn', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        customer_id: this.$store.state.customerData.id,
        contract_id: this.record.contract_id,
        date: this.record.date,
        tec_id: this.record.tec_id,
        store_id: this.record.store_id,
        added: this.record.added,
        amount: this.record.req,
        status: this.record.status
      })
        .then(res => {
          this.successShow = true
          this.errorShow = false
          this.isLoadingSave = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteSalesReturn', {
        token: localStorage.getItem('token'),
        contract_id: this.contract_id
      })
        .then(res => {
          this.record = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/SalesReturn.vue